/* eslint formatjs/no-literal-string-in-jsx: "error" */
import Breadcrumb from "components/views/atoms/Breadcrumb"
import { ArrowLink } from "components/views/atoms/links/ArrowLink"
import React from "react"
import { useHistory } from "react-router"
import styled from "styled-components"
import { Paths } from "utils/Paths"
import { FormattedMessage, useIntl } from "react-intl"

const HelpContainer = styled.div.attrs({ className: "flex items-center" })`
  margin-top: 36px;
  height: 46px;
  border-top: 1px solid #ebebeb;
`

export const NeedHelpLink = ({ baseUrl }) => {
  const history = useHistory()
  return (
    <ArrowLink onClick={() => history.push(getHelpPath({ baseUrl }))}>
      <FormattedMessage defaultMessage="I need help" />
    </ArrowLink>
  )
}

export const HelpNode = ({ baseUrl }) => (
  <HelpContainer>
    <NeedHelpLink baseUrl={baseUrl} />
  </HelpContainer>
)

export const getHelpPath = ({ baseUrl }) => `${baseUrl}/i-need-help`
export const getProviderEligibilityPath = ({ baseUrl }) => `${baseUrl}/provider-eligibility`
export const getRefreshCarrotPlanPath = ({ baseUrl }) => `${baseUrl}/refresh-carrot-plan`
export const getGetYourCarrotPlanPath = ({ baseUrl }) => `${baseUrl}/get-your-carrot-plan`
export const getAccountDeletionPath = ({ baseUrl }) => `${baseUrl}/delete-account`

export const RootBreadcrumb = () => {
  const intl = useIntl()
  const breadcrumbTitle = intl.formatMessage({
    defaultMessage: "Talk to Carrot"
  })
  const history = useHistory()
  return <Breadcrumb title={breadcrumbTitle} onClick={() => history.push(Paths.TALK_TO_CARROT)} />
}

export const SmallHeaderOverride = styled.div`
  margin-top: 32px;
`
